import { DisallowedComponentTypes } from 'src/constants';
import {
  ComponentTypes,
  DyProductSource,
  IComponent,
  ILayout,
  ISection,
  LayoutTypeIds,
} from 'src/interfaces';

export const findMatchedGlobalComponents = (
  suggestedComponentTypes: string[] = [],
  globalComponents: IComponent[] = [],
) => {
  let component: IComponent | undefined;

  if (suggestedComponentTypes.includes(DyProductSource.DYS)) {
    component = globalComponents.find(
      (component) => component.config?.productsSource === DyProductSource.DYS,
    );
  } else if (suggestedComponentTypes.includes(DyProductSource.DYR)) {
    component = globalComponents.find(
      (component) => component.config?.productsSource === DyProductSource.DYR,
    );
  } else if (suggestedComponentTypes.includes(ComponentTypes.COD_THANK_YOU)) {
    component = globalComponents.find(
      (component) =>
        component.component_type?.name === ComponentTypes.COD_THANK_YOU,
    );
  } else {
    component = globalComponents.find(
      (component) => component.component_type?.name === ComponentTypes.COD,
    );
  }

  return [{ component }];
};

export const isDisallowedOutdoorSection = (
  layout: ILayout,
  section: ISection,
) =>
  layout.layout_type_id === LayoutTypeIds.OUTDOOR &&
  !!section?.config?.suggestedComponentTypes?.some((t) =>
    DisallowedComponentTypes.includes(t),
  );
